jQuery(document).ready(function($) {

    // BACK TO TOP BUTTON
    if ($('#backTop').length) {
        var scrollTrigger = 100,
        backToTop = function () {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
                $('#backTop').addClass('show');
            } else {
                $('#backTop').removeClass('show');
            }
        };
        backToTop();
        $(window).on('scroll', function () {
            backToTop();
        });
        $('#backTop').on('click', function (e) {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }

    // COVID-19 POPUP
    $(function(){
        $('#homePop.modale').addClass('opened');
        $('.closemodale').click(function(){
            $('#homePop.modale').removeClass('opened');
        })
    })

  // Animations
  var controller = new ScrollMagic.Controller();

  var scene1 = new ScrollMagic.Scene({
    triggerElement: '#icon-animate',
  })
  scene1.setClassToggle('.cl-icon-wrap', 'animate')
  .addTo(controller);

  var scene2 = new ScrollMagic.Scene({
    triggerElement: '#homeAbout'
  })
  scene2.setClassToggle('.boy-hat', 'animate')
  .addTo(controller);

  var scene3 = new ScrollMagic.Scene({
    triggerElement: '#homeHelp'
  })
  scene3.setClassToggle('.boy-two', 'animate')
  .addTo(controller);

  var scene4 = new ScrollMagic.Scene({
    triggerElement: '#pageAbout'
  })
  scene4.setClassToggle('.boy-hat-two', 'animate')
  .addTo(controller);

  var scene5 = new ScrollMagic.Scene({
    triggerElement: '#pageWhatWeDo'
  })
  scene5.setClassToggle('.girl-two', 'animate')
  .addTo(controller);

  var scene6 = new ScrollMagic.Scene({
    triggerElement: '.title-animate'
  })
  scene6.setClassToggle('.section-title h1', 'animate')
  .addTo(controller);

  $('.hamburger').click(function () {
    $('.collapse').slideToggle('slow');
  });

  $('.hamburger').click(function () {
    $('.hamburger').toggleClass('is-active');
  });

  $('.home-carousel').flickity({
    imagesLoaded: true,
    pageDots: true,
    autoPlay: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 60, y2: 50,
      x3: 60
    }
  });

  $('.page-carousel').flickity({
    imagesLoaded: true,
    pageDots: true,
    autoPlay: true,
    arrowShape: {
      x0: 10,
      x1: 60, y1: 50,
      x2: 60, y2: 50,
      x3: 60
    }
  });

  $('.carousel').flickity({
    imagesLoaded: true,
    pageDots: false,
    prevNextButtons: true,
    hash: true,
    autoPlay: false,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 60, y2: 50,
      x3: 60
    }
  });

  $('.posts-carousel').flickity({
    imagesLoaded: true,
    pageDots: false,
    prevNextButtons: true,
    hash: true,
    autoPlay: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 60, y2: 50,
      x3: 60
    }
  });

  $('.carousel-nav').flickity({
    contain: true,
    pageDots: false,
    imagesLoaded: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 60, y2: 50,
      x3: 60
    }
  });

  $('.sponsors').flickity({
    imagesLoaded: true,
    contain: true,
    groupCells: true,
    pageDots: false,
    prevNextButtons: true,
    autoPlay: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 60, y2: 50,
      x3: 60
    }
  });

  // Fancybox
  $('a[href$="jpg"], a[href$="png"], a[href$="jpeg"]').fancybox();

  // Smooth scroll
  $('a[href*="#"]:not(.exclude_scroll a, [href="#"])').click(function(event) {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 30
        }, 500);
        return false;
      }
    }
  });

});
